module.exports = __webpack_public_path__ + "static/img/ico_user.81927ca.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/promotion/common/ico_user.png
// module id = 9rY8
// module chunks = 10